import * as React from "react";

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
  className?: string;
}

export function Icon({
  children,
  size = 24,
  className = "",
  ...props
}: React.PropsWithChildren<IconProps>) {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {children}
    </svg>
  );
}
